// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"605":"43cecce7","709":"4be7803f"}[chunkId] + ".chunk.js";
};